import styled, { css } from 'styled-components'

import theme from '../../styles/theme'

export const selectStyle = {
  control: (provided, state) => ({
    ...provided,
    height: 57,
    border: `1px solid ${state.isDisabled ? theme.gray : theme.primaryDefault} !important`,
    borderRadius: 8,
    boxShadow: 'none'
  }),
  container: (provided, state) => ({
    ...provided,
    fontSize: 18
  }),
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? 'white' : theme.primaryDefault,
    backgroundColor: state.isSelected ? theme.primaryDefault : 'white',
    opacity: state.isSelected ? 0.8 : 1
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: theme.primaryDefault,
    fontSize: 18,
    lineHeight: '24px',
    fontWeight: 600
  })
}

export const selectTheme = {
  primary: theme.primaryDefault,
  neutral50: theme.darkGray04
}

export const Container = styled.div`
  width: 100%;
  padding: 0 40px 130px;

  ${({ loadingCategories }) =>
    loadingCategories &&
    css`
      height: calc(100% - 107px);
    `};

  ${({ hidden }) =>
    hidden &&
    css`
      display: none;
    `};
`

export const Content = styled.div`
  ${({ loadingCategories }) =>
    loadingCategories &&
    css`
      height: calc(100% - 217px);
    `};

  margin-top: 50px;

  @media (orientation: landscape) {
  }

  @media (orientation: portrait) {
  }
`

export const Filters = styled.div`
  display: flex;

  @media (orientation: landscape) {
    flex-direction: row;
  }

  @media (orientation: portrait) {
    flex-direction: column;
  }
`

export const SelectWrapper = styled.div`
  flex: 1;

  > div {
    margin-top: 13px;
  }

  @media (orientation: landscape) {
    :last-child {
      margin-left: 54px;
    }
  }

  @media (orientation: portrait) {
    :last-child {
      margin-top: 40px;
    }
  }
`

export const Title = styled.p`
  font-size: 40px;
  line-height: 49px;
  color: ${theme.darkGray};
`

export const SubTitle = styled.p`
  font-size: 14px;
  line-height: 17px;
  color: ${theme.darkGray};
  margin-top: 10px;
`

export const TabWrapper = styled.div`
  display: flex;
  margin-top: 50px;
`

export const TabTitle = styled.div`
  color: ${({ isSelected }) => (isSelected ? theme.darkGray : theme.primaryDefault)};
  margin-right: 34px;
  cursor: pointer;
  transition: all 150ms ease;

  p {
    font-size: 18;
    line-height: 22px;
    ${({ isSelected }) =>
      isSelected &&
      css`
        font-weight: 600;
      `};
  }

  div {
    border: ${({ isSelected }) =>
      isSelected ? `2px solid ${theme.darkGray}` : '2px solid transparent'};
    transition: all 150ms ease;
  }
`

export const Label = styled.span`
  font-size: 12px;
  line-height: 24px;
  color: ${theme.primaryDefault};
`

export const Categories = styled.div`
  margin-top: 41px;
`

export const Grid = styled.div`
  margin-top: 13px;
  display: grid;
  grid-gap: 31px;
  grid-template-columns: repeat(auto-fit, 200px);
  justify-content: space-between;
`

export const CheckItem = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;

  span {
    font-size: 16px;
    line-height: 21px;
    color: ${theme.darkGray};
    margin-left: 7px;
  }
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
`

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

export const SelectAll = styled.span`
  font-size: 16px;
  line-height: 21px;
  color: ${theme.primaryDefault};
  cursor: pointer;
`

export const TitleInput = styled.div`
  font-size: 18px;
  line-height: 24px;
  font-weight: 600;
  color: ${theme.primaryDefault};
  margin-top: 60px;
`

export const InputWrapper = styled.div`
  flex: 1;
  margin-top: 33px;

  > input {
    margin-top: 13px;
  }
`

export const Input = styled.input`
  width: 100%;
  height: 57px;
  border: 1px solid ${theme.primaryDefault};
  border-radius: 8px;
  font-size: 18px;
  line-height: 24px;
  font-weight: 600;
  color: ${theme.primaryDefault};
  padding-left: 10px;

  ::placeholder {
    font-weight: 400;
    color: ${theme.darkGray04};
  }
`

export const WrapperCenter = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
export const BackgroundSelected = styled.span`
  position: absolute;
  width: 100%;
  height: 100%; 
  opacity: ${({ isSelected }) => (isSelected ? 0.6 : 0 )};
  background-color: #158110;
  transition: 300ms ease-in-out;
` 

export const CheckedCircle = styled.input`
  background-color: ${({ isSelected }) => (isSelected ? '#158110' : 'transparent' )};
  border-radius: 100%;
  width: 30px;
  height: 30px;
  position: absolute;
  right: 0;
  padding: 16px;
  margin: 8px;
  border: 3px solid #fff;
  z-index: 9;
`

export const CheckMark = styled.span`
  position: absolute;
  z-index: 10;
  right: 21px;
  top: 15px;
  height: 19px;
  width: 12px;
  border-bottom: 4px solid white;
  border-right: 4px solid white;
  opacity: ${({ isSelected }) => (isSelected ? 1 : 0 )};
  transform: rotate(45deg);
  transition: 300ms ease-in-out;
`

export const Modal = styled.div`
  position: ${({ opacity }) => (opacity ? 'fixed' : 'relative' )};
  opacity: ${({ opacity }) => (opacity ? 1 : 0 )};
  background-color: rgba(0, 0, 0, 0.59);
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  animation-name: ${({ opacity }) => opacity ? 'opacityFade' : ''};
  animation-duration: .6s;

  @keyframes opacityFade {
    from {opacity: 0.4;}
    to {opacity: 1;}
  }

  > div {
    background-color: white;
    height: 528px;
    width: 328px;
    display: flex;
    align-items: center;
    border-radius: 4px;
    flex-direction: column;
    justify-content: space-around;

    > img {
      margin: 0 23px 0 0;
    }

    > p {
      font-size: 16px;
      line-height: 19px;
    }

    > div {
      display: flex;
      flex-direction: column;

      > button {
        cursor: pointer;
        background-color: transparent;
        border: 2px solid ${theme.primaryDefault};
        border-radius: 50px;
        width: 140px;
        font-weight: 600;
        height: 48px;
        margin: 5px 0;
        color: ${theme.primaryDefault};
      }
    }
  }
`